import { LandingHeader } from "@/components/landing/LandingHeader"
import { HeroSection } from "@/components/landing/HeroSection"
import { PricingSection } from "@/components/landing/PricingSection"
import { SocialProofBar } from "@/components/landing/SocialProofBar"
import { ValueProposition } from "@/components/landing/ValueProposition"
import { TemplateShowcase } from "@/components/landing/TemplateShowcase"
import { HowItWorksTimeline } from "@/components/landing/HowItWorksTimeline"
import { WaitlistSection } from "@/components/landing/WaitlistSection"
import { LandingFooter } from "@/components/landing/LandingFooter"

export default function Landing() {
    return (
        <div className="min-h-screen flex flex-col">
            <LandingHeader />
            <main className="flex-1">
                <HeroSection />
                <PricingSection />
                <SocialProofBar />
                <ValueProposition />
                <TemplateShowcase />
                <HowItWorksTimeline />
                <WaitlistSection />
            </main>
            <LandingFooter />
        </div>
    )
}
